import { render } from "./ChangePass.vue?vue&type=template&id=689f837c&scoped=true"
import script from "./ChangePass.vue?vue&type=script&lang=ts"
export * from "./ChangePass.vue?vue&type=script&lang=ts"

import "./ChangePass.vue?vue&type=style&index=0&id=689f837c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-689f837c"

export default script